const vertexShader = `

precision highp float;
precision highp int;

uniform float time;

// attribute vec3 position;
// attribute vec3 normal;
// attribute vec2 uv;
attribute vec2 uv2;

varying vec3 vPosition;
varying vec3 vNormal;
varying vec2 vUv;
varying vec2 vUv2;

void main() {

    vNormal = normal;
    vUv = uv;
    vUv2 = uv2;
    vPosition = position;

    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

}
`;

export default vertexShader;
